import React, { useEffect, useRef } from 'react';
import cn from 'classnames';

import Tag from '../UIkit/Tag';
import style from './CustomerFocus.module.css';
import { CUSTOMERFOCUS } from './constants';

const CustomerFocus = () => {

  const containerRef = useRef<HTMLDivElement>(null);
  const itemsRef = useRef<NodeListOf<Element>>();

  useEffect(() => {
    if (!containerRef.current) return;

    itemsRef.current = containerRef.current.querySelectorAll(`.${style.item}`);
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(style.visible);
          }
        });
      },
      {
        root: document.querySelector('.your-scroll-container'),
        threshold: 0.1,
      },
    );

    itemsRef.current.forEach(item => observer.observe(item));

    return () => {
      itemsRef.current!.forEach(item => observer.unobserve(item));
    };
  }, []);
  return (
    <article ref={containerRef}>
      <div className={style.container} id="clients1">
        <div className={style.header}>
          <h2 className={style.h2}>Клиентоориентированность</h2>
          <Tag title={'Мы предлагаем'} color="white" />
        </div>
        <div className={style.grid} data-scroll-speed="0.5">
          {CUSTOMERFOCUS.items.map(el => {
            if (!el.description) {
              return (
                <div
                  key={`CustomerFocus_${el.id}`}
                  className={cn(style.item, style.imgbox)}
                  data-scroll
                  // data-scroll-class={style.visible}
                >
                  {/* <img src={el.img} alt="" /> */}
                </div>
              );
            }
            return (
              <div
                key={`CustomerFocus_${el.id} _${el.title}`}
                className={cn(style.card, style.item)}
                data-scroll
                data-scroll-class={style.visible}
              >
                <el.icon />
                <div className={style.title}>{el.title}</div>
                <p className={style.description}>{el.description}</p>
                <div className={style.id}>{String(el.id).padStart(2, '0')}</div>
              </div>
            );
          })}
        </div>
      </div>
      {/* {!isBY && <Clients1 />} */}
    </article>
  );
};

export default CustomerFocus;
